import CreateTeamContainer from "../containers/CreateTeamContainer";

const CreateTeamPage = () => {
  return (
    <CreateTeamContainer />
  );
};

export default CreateTeamPage;
